const apiUrl = 'https://cms.updatetechltd.com'; //WITH TRAILING SLASH @ END
// const apiUrl = 'http://localhost:9000'; //WITH TRAILING SLASH @ END
const baseUrl = "https://updatetechltd.com";

module.exports = {
    apiUrl: apiUrl,
    baseUrl: baseUrl,
}